import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import PropTypes from 'prop-types';
import React from 'react';
import { ComponentsProvider, FILTERS_NAMESPACE } from '@panneau/core/contexts';
import filterButton from '@panneau/filter-button';
import filterDate from '@panneau/filter-date';
import filterRadios from '@panneau/filter-radios';
import filterSearch from '@panneau/filter-search';
import filterSelect from '@panneau/filter-select';
import filterToggle from '@panneau/filter-toggle';
import filterLabel from '@panneau/filter-label';
import filterFilters from '@panneau/filter-filters';

var components = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Button: filterButton,
    Date: filterDate,
    Filters: filterFilters,
    Label: filterLabel,
    Radios: filterRadios,
    Search: filterSearch,
    Select: filterSelect,
    Toggle: filterToggle
});

var _excluded = ["components", "children"];
var propTypes = {
  components: PropTypes.object,
  // eslint-disable-line
  children: PropTypes.node
};
var defaultProps = {
  components: null,
  children: null
};
var FiltersProvider = function FiltersProvider(_ref) {
  var injectedComponents = _ref.components,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ComponentsProvider, Object.assign({
    namespace: FILTERS_NAMESPACE,
    components: _objectSpread(_objectSpread({}, components), injectedComponents)
  }, props), children);
};
FiltersProvider.propTypes = propTypes;
FiltersProvider.defaultProps = defaultProps;

export { FiltersProvider as default };
